import React, { useReducer } from 'react'
import CommonContext from './commonContext'
import CommonReducer from './commonReducer'
import { apiCall } from '@/product/common/api'
import { response } from '@/product/context/common'

import {
    COMMON_VALUES,
    RESPONSE_STATUS,
    CLEAR_RESPONSE,
    GET_CHARITY_DETAILS,
    GET_CHARITY_DETAILS_BY_ID,
    SEARCH_JUSTGIVING_CHARITY,
} from './commonTypes'

const CommonState = (props) => {
    const initialState = {
        allCategory: [],
        allLocations: [],
        allCondition: [],
        allfaq: [],
        allNotifications: [],
        allConfigurationVariables: {},
        allBidIncrements: [],
        alldata_all_dropdown: [],
        allUi: [],
        responseStatus: null,
        allTaxCodeList: [],
        allHomeBanner: [],
        allMaintanenceData: {},
        all_charity_details: {
            records: [],
            totalRecords: 0,
            setDisp: '',
        },
        all_charity_details_by_id: {
            records: [],
            totalRecords: 0,
            setDisp: '',
        },
        charityDetails: {
            records: [],
            from: '',
        },
    }

    const [state, dispatch] = useReducer(CommonReducer, initialState)
    let resp = new response(dispatch, RESPONSE_STATUS)

    const getGlobalVariable = async (type) => {
        const [res] = await Promise.all([
            apiCall('post', 'getDefault', {}, '', '', true),
        ])
        if (res.data.status === 'success') {
            console.log('res.data', res.data)
            dispatch({
                type: COMMON_VALUES,
                payload: {
                    allCategory:
                        res.data.data.responseData.tableValues.allcategorytypes.filter(
                            (value) => value.active != 2
                        ),
                    allNotifications:
                        res.data.data.responseData.tableValues
                            .allall_notifications,
                    allConfigurationVariables:
                        res.data.data.responseData.variables,
                    allLocations:
                        res.data.data.responseData.tableValues.alllocations.filter(
                            (value) => value.active != 2
                        ),
                    allCondition:
                        res.data.data.responseData.tableValues.allconditiontypes.filter(
                            (value) => value.active != 2
                        ),
                    allfaq: res.data.data.responseData.tableValues?.allfaq
                        ? res.data.data.responseData.tableValues.allfaq.filter(
                              (value) => value.active != 2
                          )
                        : [],
                    allMaintanenceData:
                        res.data.data.responseData.maintanenceData,
                    alldata_all_dropdown: res.data.data.responseData.tableValues
                        .alldata_all_dropdown
                        ? res.data.data.responseData.tableValues.alldata_all_dropdown.filter(
                              (value) => value.active != 2
                          )
                        : [],
                    allUi: res.data.data.responseData.tableValues
                        .allui_settings,
                    allBidIncrements:
                        res.data.data.responseData.allBidIncrements,
                    bidIncrementDefault:
                        res.data.data.responseData.bidIncrementDefault,
                    allTaxCodeList:
                        res.data.data.responseData.tableValues.alltax_code_list,
                    allHomeBanner:
                        res.data.data.responseData.tableValues.allhome_banner,
                },
            })
        }
    }

    const searchJustGivingCharity = async (
        formData,
        fromVariable = 'search'
    ) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'charity', formData, '', 'search', true, true),
            ])

            console.log(res.data, 'nnnnnnnnn')

            if (res.data.status === 'success') {
                dispatch({
                    type: SEARCH_JUSTGIVING_CHARITY,
                    payload: {
                        records: res.data.data.responseData.length
                            ? res.data.data.responseData
                            : [],
                        totalRecords: 0,
                        setDisp: 0,
                        sorts: 0,
                        from: fromVariable,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, fromVariable)
            } else {
                resp.commonErrorResponse(fromVariable)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const getAllCharityDetails = async (formData) => {
        const from = 'justgiving_charity'
        try {
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'getCharity',
                    formData,
                    '',
                    'third_party/justgiving'
                ),
            ])
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_CHARITY_DETAILS,
                    payload: {
                        records: res.data?.data?.responseData?.GroupedResults
                            ?.Results?.length
                            ? res.data.data.responseData.GroupedResults.Results
                            : [],
                        // totalRecords: res.data.data.responseData.totalRecords,
                        // setDisp: res.data.data.responseData.setDisp,
                        from: from,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const getAllCharityDetailsById = async (
        formData,
        froms = 'justgiving_charity'
    ) => {
        const from = froms
        try {
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'getCharityById',
                    formData,
                    '',
                    'third_party/justgiving'
                ),
            ])
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_CHARITY_DETAILS_BY_ID,
                    payload: {
                        records: res.data?.data?.responseData?.length
                            ? res.data.data.responseData
                            : [],

                        from: from,
                    },
                })
            } else if (res.data.status === 'error') {
                dispatch({
                    type: GET_CHARITY_DETAILS_BY_ID,
                    payload: {
                        records: res.data?.data?.responseData?.length
                            ? res.data.data.responseData
                            : [],

                        from: from,
                    },
                })
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const clearResponse = () =>
        dispatch({
            type: CLEAR_RESPONSE,
        })
    return (
        <CommonContext.Provider
            value={{
                allCategory: state.allCategory,
                allNotifications: state.allNotifications,
                allLocations: state.allLocations,
                allCondition: state.allCondition,
                allBidIncrements: state.allBidIncrements,
                allUi: state.allUi,
                allConfigurationVariables: state.allConfigurationVariables,
                alldata_all_dropdown: state.alldata_all_dropdown,
                responseStatus: state.responseStatus,
                allTaxCodeList: state.allTaxCodeList,
                allHomeBanner: state.allHomeBanner,
                allfaq: state.allfaq,
                allMaintanenceData: state.allMaintanenceData,
                all_charity_details: state.all_charity_details,
                all_charity_details_by_id: state.all_charity_details_by_id,
                charityDetails: state.charityDetails,
                getGlobalVariable,
                clearResponse,
                getAllCharityDetails,
                getAllCharityDetailsById,
                searchJustGivingCharity,
            }}
        >
            {props.children}
        </CommonContext.Provider>
    )
}

export default CommonState
